// components/Login.tsx

import { useLoginViewModel } from "./LoginViewModel";
import { LoginView } from "./LoginView";

const Login = (props: any) => {
  const vm = useLoginViewModel(props);
  return <LoginView {...vm} />;
};

export default Login;